<div [formGroup]="form" fxLayout="column">
  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Occurrence Date</mat-label>
      <input
        matInput
        formControlName="occurrenceDate"
        [matDatepicker]="occurrenceDatePicker"
        [min]="minDate"
        [max]="maxDate"
        required
      />
      <mat-datepicker-toggle matSuffix [for]="occurrenceDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #occurrenceDatePicker></mat-datepicker>
      <mat-error *ngIf="form.controls.occurrenceDate.hasError('matDatepickerMin')"
        >Start date is too far in the past.</mat-error
      >
      <mat-error *ngIf="form.controls.occurrenceDate.hasError('matDatepickerMax')"
        >Start date must be on or before today.</mat-error
      >
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <fl-autocomplete
      fxFlex="395px"
      [placeholder]="'Record Type*'"
      [inputControl]="form.controls.recordTypeId"
      [options]="recordTypeOptions$ | async"
      (search)="onRecordTypeSearch($event)"
      [useMatInput]="true"
      [errors]="getControlRequiredError(form.controls.recordTypeId)"
      [initialSelectedItem]="selectedRecordType"
      [fullWidth]="true"
    >
    </fl-autocomplete>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <fl-autocomplete
      fxFlex="395px"
      [placeholder]="'Report Type*'"
      [inputControl]="form.controls.reportTypeId"
      [options]="reportTypeOptions$ | async"
      (search)="onReportTypeSearch($event)"
      [useMatInput]="true"
      [errors]="getControlRequiredError(form.controls.reportTypeId)"
      [initialSelectedItem]="selectedReportType"
      [hint]="'Select a Record Type to get Report Type options'"
      [fullWidth]="true"
    >
    </fl-autocomplete>
  </div>
  <div fxLayout="row" fxLayoutGap="10px">
    <fl-autocomplete
      fxFlex="395px"
      [placeholder]="'Test Type*'"
      [inputControl]="form.controls.testTypeId"
      [options]="testTypeOptions$ | async"
      (search)="onTestTypeSearch($event)"
      [useMatInput]="true"
      [errors]="getControlRequiredError(form.controls.testTypeId)"
      [initialSelectedItem]="selectedTestType"
      [hint]="'Select a Report Type to get Test Type options'"
      [fullWidth]="true"
    >
    </fl-autocomplete>
  </div>

  <div fxLayout="row" fxLayoutGap="10px">
    <mat-form-field>
      <mat-label>Processing State</mat-label>
      <mat-select formControlName="processingState">
        <mat-option
          *ngFor="let option of processingStateOptions"
          [value]="option.value"
          [disabled]="!option.selectable"
        >
          {{ option.value | humanize }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
